import type { ServiceQueryResultWithStatus, ServiceQueryResult } from './types';

/**
 * Transform the data contained within a service result.
 */
export const mapServiceResult = <In, Out>(
	result: ServiceQueryResultWithStatus<In>,
	transform: (arg1: In) => Out,
): ServiceQueryResultWithStatus<Out> =>
	result.data === undefined
		? {
				...result,
				data: undefined,
			}
		: {
				...result,
				data: transform(result.data),
			};

export const resourceResultToServiceQueryResult = <T,>({
	data,
	loading,
	error, // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: any): ServiceQueryResult<T> => ({
	data: data === null ? undefined : data,
	loading,
	error: error === null ? undefined : error,
});
